module.exports = __webpack_public_path__ + "img/header-diamondJewelryCollectionRings.8e2558f.webp";